import { render, staticRenderFns } from "./TabBusinessTermView.vue?vue&type=template&id=5b1ac2ce&lang=pug"
import script from "./TabBusinessTermView.vue?vue&type=script&lang=js"
export * from "./TabBusinessTermView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b1ac2ce')) {
      api.createRecord('5b1ac2ce', component.options)
    } else {
      api.reload('5b1ac2ce', component.options)
    }
    module.hot.accept("./TabBusinessTermView.vue?vue&type=template&id=5b1ac2ce&lang=pug", function () {
      api.rerender('5b1ac2ce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/tableau/datasource/TabBusinessTermView.vue"
export default component.exports